import script from "./listmobile.vue?vue&type=script&setup=true&lang=js"
export * from "./listmobile.vue?vue&type=script&setup=true&lang=js"

import "./listmobile.vue?vue&type=style&index=0&id=0c1e2fec&lang=less"

const __exports__ = script;

export default __exports__